import { atom } from "jotai";
import {
	type SupportedLocale,
	applyLocale,
	readLocale,
	writeLocale,
} from "../lib/locale";

export const localeAtom = atom<SupportedLocale>(readLocale());

export const initializeLocaleAtom = atom(null, (_get, set) => {
	const locale = readLocale();
	applyLocale(locale);
	set(localeAtom, locale);
	return locale;
});

export const setLocaleAtom = atom(
	null,
	(_get, set, locale: SupportedLocale) => {
		writeLocale(locale);
		applyLocale(locale);
		set(localeAtom, locale);
	},
);
